// extracted by mini-css-extract-plugin
export default {"toast":"Notification_toast__58vvL","text":"Notification_text__oPTah"};